import { isValidPhoneNumber } from "libphonenumber-js";
import { useTranslations } from "next-intl";
import { ref, string, StringSchema } from "yup";

const nameRegex = /^[\p{L}]+$/u;

const useInputValidation = (): {
  passwordLightSchema: StringSchema;
  passwordSchema: StringSchema;
  passwordConfirmSchema: StringSchema;
  emailSchema: StringSchema;
  phoneSchema: StringSchema;
  nameSchema: StringSchema;
  descriptionSchema: StringSchema;
  firstNameSchema: StringSchema;
  lastNameSchema: StringSchema;
  _requiredStringSchema: StringSchema;
} => {
  const t = useTranslations();

  return {
    passwordLightSchema: string()
      .required(t("Required"))
      .min(6, t("Minimum {quantity} characters", { quantity: 6 })),
    passwordSchema: string()
      .required(t("Required"))
      .min(6, t("Minimum {quantity} characters", { quantity: 6 }))
      .max(128, t("Maximum {quantity} characters", { quantity: 128 }))
      .matches(/.*\d/, t("At least 1 digit"))
      .matches(/.*\p{Ll}/u, t("At least 1 lowercase letter"))
      .matches(/^.*\p{Lu}/u, t("At least 1 capital letter"))
      .matches(/.*[^\d\p{Ll}\p{Lu} ]/u, t("At least 1 special character"))
      .matches(
        /^(?=.*\d)(?=.*\p{Ll})(?=.*\p{Lu})(?=.*[^\d\p{Ll}\p{Lu}])(?!.*\s).{8,128}$/u,
        t("Space cannot be used"),
      ),

    passwordConfirmSchema: string()
      .required(t("Required"))
      .oneOf([ref("password")], t("Passwords must match")),
    passwordNewConfirmSchema: string()
      .required(t("Required"))
      .oneOf([ref("newPassword")], t("Passwords must match")),
    emailSchema: string()
      .required(t("Required"))
      .email(t("Please enter a valid email")),
    phoneSchema: string()
      .required(t("Required"))
      .test("invalidPhone", t("Please enter a valid phone number"), (val) => {
        try {
          return isValidPhoneNumber(val || "");
        } catch (error) {
          return false;
        }
      }),
    nameSchema: string().required(t("Required")),
    descriptionSchema: string().required(t("Required")),
    firstNameSchema: string()
      .required(t("Required"))
      .matches(nameRegex, t("OnlyLettersAllowed")),
    lastNameSchema: string()
      .required(t("Required"))
      .matches(nameRegex, t("OnlyLettersAllowed")),
    _requiredStringSchema: string().required(t("Required")),
  };
};

export default useInputValidation;
